export default __webpack_public_path__ + "static/media/group_stats_charts.03400bac.png";